module.exports = __webpack_public_path__ + "static/user-dbb521f29a4cade72521b37edb57cc36.png";